import * as React from "react";
const SvgFiRrFox = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fox_svg__a)">
      <path
        fill="#062147"
        d="M23.241.435a1.98 1.98 0 0 0-1.7-.383 6.13 6.13 0 0 0-4.141 3.73A22 22 0 0 0 12 3c-1.825.034-3.64.297-5.4.782A6.13 6.13 0 0 0 2.456.052a1.98 1.98 0 0 0-1.7.383A2 2 0 0 0 0 2.006v7.852a10.93 10.93 0 0 0 3.222 7.778l4.657 4.657a5.86 5.86 0 0 0 8.242 0l4.657-4.657A10.93 10.93 0 0 0 24 9.858V2.006a2 2 0 0 0-.759-1.57M5.051 5.316a1 1 0 0 0 1.264.633A21 21 0 0 1 12 5c1.93.053 3.843.372 5.685.95a1 1 0 0 0 1.263-.634c.617-1.849 1.671-2.995 3.052-3.31v6.167c-2.428.56-9 2.811-9 10.827v.184a2.87 2.87 0 0 0-2 0V19c0-8.015-6.571-10.268-9-10.827V2c1.381.321 2.435 1.468 3.051 3.316m-.415 10.906a8.93 8.93 0 0 1-2.618-6q1.025.27 1.982.723V11a3.78 3.78 0 0 0 3.6 2.978A8.85 8.85 0 0 1 9 19v1.586zm14.728 0L15 20.586V19a8.85 8.85 0 0 1 1.4-5.022A3.78 3.78 0 0 0 20 11v-.055q.957-.453 1.982-.722a8.93 8.93 0 0 1-2.618 6"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fox_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFox;
